import { FACINGMODE_OPTIONS } from '@/constants/liveRoom'
type Params = {
  currentVideoInputId: string
  frameRate: string
  width: string
  height: string
}

function isLandscape(): boolean {
  return window.innerWidth > window.innerHeight
}

export const getVideoConstraints = ({ currentVideoInputId, frameRate, width, height }: Params) => {
  const constraints: { [key: string]: any } = {
    frameRate: {
      ideal: Number(frameRate),
    },
    width: {
      ideal: isLandscape() ? Number(width) : Number(height),
    },
    height: {
      ideal: isLandscape() ? Number(height) : Number(width),
    },
    aspectRatio: {
      exact: isLandscape() ? Number(width) / Number(height) : Number(height) / Number(width),
    },
  }

  if (FACINGMODE_OPTIONS.includes(currentVideoInputId)) {
    constraints['facingMode'] = {
      exact: currentVideoInputId,
    }
  } else {
    constraints['deviceId'] = {
      exact: currentVideoInputId,
    }
  }
  return constraints
}
